@if (candidate) {
  <div
    #defaultEvalDropdownTrigger="rtOverlayOrigin"
    [class.evaluation-container]="showEvaluation && hasRating(candidate)"
    [class.bordered]="hasBorder"
    [class.disabled]="disabled"
    [class.dropdownOpened]="evalDropdown.open"
    [class.hovered]="state.hover"
    rt-overlay-origin
  >
    @if (hasTriggerContent) {
      @if (showEvaluation) {
        @if (!hasRating(candidate)) {
          <rt-group>
            <rt-button variant="plain">
              <rt-icon name="thumbs-up-down"> </rt-icon>
              <span> {{ 'app.interview.not_evaluated' | translate }} </span>
            </rt-button>
          </rt-group>
        }

        @if (hasRating(candidate)) {
          <div layout-vertical>
            <div layout-horizontal>
              @if (candidate.ratingVisible) {
                <rt-interview-evaluation-rating
                  [rating]="candidate.positiveRatings"
                  [tooltip]="false"
                >
                </rt-interview-evaluation-rating>
                <rt-heading
                  [variant]="hasNewCandidateProfile ? 'dark size-default' : 'heading large'"
                  [attr.text-weight-semi-bold]="hasNewCandidateProfile || null"
                >
                  {{ candidate.positiveRatings }}%
                </rt-heading>
              }
              @if (!candidate.ratingVisible) {
                <rt-hidden-score-icon></rt-hidden-score-icon>
              }
            </div>
            @if (hasQuickEvaluationDropdown) {
              @if (hasMyLastRating() && !state.hover && !evalDropdown.open) {
                <div class="current-admin-rating-wrap" layout-horizontal>
                  <span class="small-label">
                    {{ 'app.interview.you_gave_base' | translate }}
                  </span>
                  <rt-interview-evaluation-rating
                    [tooltip]="false"
                    [colorize]="false"
                    [rating]="state.myLastRating!"
                    [size]="'small'"
                    margin-left-small-xx
                  >
                  </rt-interview-evaluation-rating>
                </div>
              } @else {
                <span class="small-label">
                  {{ evaluationScoreCopy }}
                </span>
              }
            }
            @if (!hasQuickEvaluationDropdown) {
              <span class="small-label">
                {{ 'app.interview.evaluation_score' | translate }}
              </span>
            }
          </div>
        }
      }

      @if (!showEvaluation) {
        <rt-group>
          <rt-button
            [pressed]="evalDropdown.open"
            (click)="openDropdown(evalDropdown)"
            variant="primary"
          >
            <rt-icon name="add"></rt-icon>
            <span> {{ 'app.interview.add_evaluation' | translate }}</span>
          </rt-button>
        </rt-group>
      }
    }
  </div>
}

<ng-template
  #evalDropdown="rtConnectedOverlay"
  [positions]="hasQuickEvaluationDropdown ? quickDropdownPositions : $any(null)"
  [origin]="defaultEvalDropdownTrigger"
  (backdropClick)="evalDropdown.open = false; evalDropdownClose.emit()"
  rt-connected-overlay
  hasBackdrop
>
  @if (!hasQuickEvaluationDropdown) {
    <rt-add-evaluation-dropdown
      [allowedUsers]="allowedUsers"
      [templates]="state.templates"
      [offers]="state.offers"
      [dropdownRef]="evalDropdown"
      [candidate]="candidate"
      (submit)="onSubmit({ event: $event })"
      (close)="evalDropdownClose.emit()"
    >
    </rt-add-evaluation-dropdown>
  }
  @if (hasQuickEvaluationDropdown) {
    <rt-add-quick-evaluation-dropdown
      [candidate]="candidate"
      [placement]="placement"
      [hasAccessToAllJobOffers]="hasAccessToAllJobOffers"
      [availablePlacements]="currentUserAvailablePlacements"
      [dropdownRef]="evalDropdown"
      [isActionToolbar]="isActionToolbar"
      [quickEvaluationTrigger]="quickEvaluationTrigger"
      (optionsClick)="optionsClick.emit($event)"
      (closeDialog)="evalDropdownClose.emit()"
    >
    </rt-add-quick-evaluation-dropdown>
  }
</ng-template>

@if (showEvaluation) {
  <div
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="handleClick()"
    class="action-area"
  ></div>
}
